import { LegacyPortalShippingStatusDeliveryCarrier } from "@spwn-portal/grpc";

import type { i18nStringType } from "i18n/i18nString";

export const getDeliveryCarrierName = (
  deliveryCarrier: LegacyPortalShippingStatusDeliveryCarrier
): i18nStringType => {
  switch (deliveryCarrier) {
    case LegacyPortalShippingStatusDeliveryCarrier.YAMATO:
      return "settlementHistory.delivery.carrier.yamato";
    case LegacyPortalShippingStatusDeliveryCarrier.SAGAWA:
      return "settlementHistory.delivery.carrier.sagawa";
    case LegacyPortalShippingStatusDeliveryCarrier.UNSELECTED:
      return "settlementHistory.delivery.carrier.unselected";
    case LegacyPortalShippingStatusDeliveryCarrier.UNSPECIFIED:
    default:
      return "settlementHistory.delivery.carrier.unknown";
  }
};
